// Libellés des types d'orientation — miroir de USER_ORIENTATION_TYPES /
// TypeOrientation côté API (non exposés par constants/BOA).
export const ORIENTATION_TYPE_LABELS = {
  AUTO: "Automatique (algorithme)",
  AUTO_CD: "Automatique CD",
  STOCK: "Stock",
  USER_MANAGER: "Orienté par un agent",
  OVERRIDE_AUTO: "Modification résultat auto par un agent",
  EP: "Orienté suite à décision EP",
  UPDATE_WITHOUT_REO: "Modification directe par un agent",
  REORIENTATION: "Orienté suite à une réorientation",
};

export const getOrientationTypeLabel = (type) => ORIENTATION_TYPE_LABELS[type] ?? type ?? "";
